import CreatePersonSurvey from './components/surveys/Person/CreatePersonSurvey';
import ViewPersonSurveys from './components/surveys/Person/PersonSurveys';
import SubmittedSurvey from './components/surveys/SubmittedSurvey';
import Forms from './components/surveys/Forms';
import Surveys from './components/surveys/Surveys';
import SiteDetails from './components/StudySiteDetails';
import PageNotFound from './components/utility/PageNotFound';
import AdminPanel from './components/admin/salesforce/AdminPanel';
import ShowUserProfile from './components/admin/salesforce/users/ShowUserProfile';
import CreateUser from './components/admin/salesforce/users/CreateUser';
import MainApplicationAccess from './components/access-requests/application-access/MainApplicationAccess';
import Milestones from './components/milestones/Milestones';
import Enrollments from './components/enrollments/Enrollments';
import HelpTopic from './components/support/HelpTopic';
import Support from './components/support/Support';
import CustomRequestApplicationAccess from './components/access-requests/custom-request/CustomRequestApplicationAccess';
import PfizerApplicationSupport from './components/support/ApplicationSupport/PfizerApplicationSupport';
import AccessRequestManager from './components/access-requests/application-access-manager/ApplicationAccessManager';
import PfizerApplicationSupportTopic from './components/support/ApplicationSupport/PfizerApplicationSupportTopic';
import EnrollmentOversight from './components/enrollment-oversight/EnrollmentOversight';
import ManageAccess from './components/access-requests/application-access-manager/manage-access/ManageAccess';
import ViewAllRequests from './components/access-requests/application-access-manager/view-all-requests/ViewAllRequests';
import SelectStudySite from './components/access-requests/application-access-manager/manage-access/SelectStudySite';
import ManageRequest from './components/access-requests/ManageRequest';
import TicketDetails from './components/access-requests/application-access/TicketDetails';
import StartUpPlan from './components/start-up-plan/StartUpPlan';
import AnonymousForm from './components/forms/anonymous/AnonymousForm.vue';
import AnonymousFormSelectStudySite from './components/forms/anonymous/AnonymousFormSelectStudySite.vue';
import MissionControlEvents from './components/MissionControlEvents.vue';
import ThankYou from './components/common/ThankYou.vue';
import NotAllowed from './components/utility/NotAllowed.vue';
import DocumentSecurity from './components/utility/DocumentSecurity';
import Studies from './components/Studies.vue';
import SiteSummary from './components/summary/SiteSummary.vue';
import StudySubject from './components/subjects/StudySubject.vue';

import TermsOfUse from './components/support/TermsOfUse';
import ApplicationSupportNumbers from './components/support/ApplicationSupport/ApplicationSupportNumbers';

import SafetyContactsAdmin from './components/admin/SafetyContactsAdmin.vue';
import SafetyContacts from './components/support/ApplicationSupport/SafetyContacts.vue';

export const routes = [
  {
    path: '/admin/safety-contacts',
    name: 'safety-contacts-admin',
    component: SafetyContactsAdmin,
    props: true,
  },
  {
    path: '/safety-contact-phone-numbers',
    name: 'safety-contacts',
    component: SafetyContacts,
    props: true,
  },
  {
    path: '/custom-application-access/:studyId?/:siteId?',
    name: 'custom-application-access',
    component: CustomRequestApplicationAccess,
    props: true,
  },
  // My Study-Sites
  {
    path: '/study-sites',
    name: 'studies',
    component: Studies,
    props: true,
    children: [
      {
        path: ':studyId/:siteId',
        name: 'site-details',
        component: SiteDetails,
        props: true,
        children: [
          {
            path: 'site-summary',
            name: 'site-summary',
            component: SiteSummary,
            props: true,
          },

          { path: 'not-allowed', name: 'not-allowed', component: NotAllowed, props: true },
          // Study SUbject
          {
            path: 'study-subject',
            name: 'study-subject',
            component: StudySubject,
            meta: { permission: 'access my enrollments' },
          },
          // Start Up Plan
          {
            path: 'start-up-plan',
            name: 'start-up-plan',
            component: StartUpPlan,
            meta: { permission: 'access start-up plan' },
          },
          // Enrollment
          {
            path: 'site-enrollment',
            name: 'site-enrollment',
            component: Enrollments,
            meta: { permission: 'access my enrollments' },
          },
          // Milestones
          {
            path: 'study-site-milestones',
            name: 'study-site-milestones',
            component: Milestones,
            meta: { permission: 'access milestones' },
          },
          // My Access Requests
          {
            path: 'application-access',
            name: 'application-access',
            component: MainApplicationAccess,
            meta: { permission: 'access application access' },
            children: [
              {
                path: 'ticket/:id',
                name: 'ticket-details',
                component: TicketDetails,
                meta: { permission: 'access application access' },
              },
            ],
          },
          // System Outage Messages
          {
            path: 'system-outage-messages',
            name: 'system-outage-messages',
            component: MissionControlEvents,
            meta: { permission: 'access system outage messages' },
          },
          // Forms
          {
            path: 'forms',
            name: 'forms',
            component: Forms,
            meta: { permission: 'access forms' },
            children: [
              {
                path: ':eventId',
                name: 'form-create',
                component: CreatePersonSurvey,
                meta: { permission: 'access forms' },
              },
            ],
          },
        ],
      },
    ],
  },
  //support
  {
    path: '/support',
    name: 'support',
    component: Support,
    props: true,
  },
  {
    path: '/support/:category/:Id',
    name: 'help-topic',
    component: HelpTopic,
    props: true,
  },
  {
    path: '/support/pfizer-application-support',
    name: 'pfizer-application-support',
    component: PfizerApplicationSupport,
    children: [
      {
        path: 'help-topic/:topicId',
        name: 'pfizer-application-support-help-topic',
        component: PfizerApplicationSupportTopic,
        props: true,
      },
    ],
  },

  //terms of use
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    component: TermsOfUse,
  },

  // Person Surveys
  {
    path: '/surveys',
    name: 'surveys',
    component: Surveys,
    props: true,
    meta: { permission: 'access surveys' },
  },
  {
    path: '/surveys/event/:eventId/create',
    component: CreatePersonSurvey,
    name: 'create-person-survey',
  },
  {
    path: '/surveys/event/:eventId/create/surveyId/:surveyId',
    component: CreatePersonSurvey,
    name: 'create-person-survey-from-view-all',
  },
  {
    path: '/surveys/event/:eventId/view-all',
    component: ViewPersonSurveys,
    name: 'view-person-surveys',
  },
  {
    path: '/surveys/event/:eventId/view/surveyId/:surveyId/survey/view-submitted',
    component: SubmittedSurvey,
    name: 'view-person-submitted-survey',
  },

  // Enrollment Oversight
  {
    path: '/enrollment-oversight',
    name: 'enrollment-oversight',
    component: EnrollmentOversight,
    props: true,
    meta: { permission: 'access enrollment oversight' },
    children: [
      {
        path: 'sites/:studyId/:siteId',
        name: 'oversight-site-details',
        component: SiteDetails,
        props: true,
        children: [
          {
            path: 'not-allowed',
            name: 'oversight-not-allowed',
            component: NotAllowed,
            props: true,
          },
          // Start Up Plan
          {
            path: 'start-up-plan',
            name: 'oversight-start-up-plan',
            component: StartUpPlan,
            meta: { permission: 'access start-up plan' },
          },
          // Enrollment
          {
            path: 'site-enrollment',
            name: 'oversight-site-enrollment',
            component: Enrollments,
            meta: { permission: 'access my enrollments' },
          },
          // Milestones
          {
            path: 'study-site-milestones',
            name: 'oversight-study-site-milestones',
            component: Milestones,
            meta: { permission: 'access milestones' },
          },
          // My Access Requests
          {
            path: 'application-access',
            name: 'oversight-application-access',
            component: MainApplicationAccess,
            meta: { permission: 'access application access' },
          },
          // System Outage Messages
          {
            path: 'system-outage-messages',
            name: 'oversight-system-outage-messages',
            component: MissionControlEvents,
            meta: { permission: 'access system outage messages' },
          },
        ],
      },
    ],
  },

  //Admin
  {
    path: '/admin/salesforce',
    name: 'salesforce-admin-panel',
    component: AdminPanel,
  },
  {
    path: '/admin/salesforce/users/create',
    name: 'salesforce-user-create',
    component: CreateUser,
  },
  {
    path: '/admin/salesforce/users/:userId',
    name: 'salesforce-user-profile',
    component: ShowUserProfile,
  },

  {
    path: '/application-access-manager',
    name: 'application-access-manager',
    component: AccessRequestManager,
    children: [
      {
        path: 'manage-access',
        name: 'application-access-manager-manage-access',
        component: ManageAccess,
      },
      {
        path: 'person/:personId/select-study-site',
        name: 'application-access-manager-select-study-site',
        component: SelectStudySite,
        props: true,
        children: [
          {
            path: 'study/:studyId/site/:siteId/create-request',
            name: 'application-access-manager-create-request',
            component: ManageRequest,
            props: true,
          },
        ],
      },
      {
        path: 'view-all-requests',
        name: 'application-access-manager-view-all-requests',
        component: ViewAllRequests,
      },
    ],
  },

  {
    path: '/anonymous-form',
    name: 'anonymous-form',
    component: AnonymousForm,
    props: true,
  },
  {
    path: '/anonymous-form/select-study-site',
    name: 'anonymous-form-select-study-site',
    component: AnonymousFormSelectStudySite,
    props: true,
    children: [
      {
        path: 'study/:studyId/site/:siteId/create-request',
        name: 'anonymous-access-request',
        component: ManageRequest,
        props: true,
      },
    ],
  },

  {
    path: '/thank-you',
    name: 'thank-you',
    component: ThankYou,
  },

  { path: '/not-found', name: 'not-found', component: PageNotFound },
  // 404!
  { path: '*', component: PageNotFound },

  {
    path: '/document/:responseId',
    component: DocumentSecurity,
    name: 'document-security',
  },

  {
    path: '/applicationsupport',
    name: 'application-support',
    component: ApplicationSupportNumbers,
    props: true,
  },
];
